import React from 'react';
import PropTypes from 'prop-types';
import Copy from './ui/Copy';
import Link from './ui/Link';
import Text from './ui/Text';

function Caption(props) {
  const { className, title, year, text, copy, showCourtesy, videos } = props;
  return (
    <ul className={`list list-small margin-top ${className ? className : ''}`}>
      {title && <li className="text-italic">{title}</li>}
      {year && <li>{year}</li>}
      {text && (
        <li>
          <Text text={text} useParser />
        </li>
      )}
      {copy && (
        <li>
          <Copy text={copy} />
        </li>
      )}
      {showCourtesy && <li>Courtesy of the artists </li>}
      {videos &&
        videos.length > 0 &&
        videos.map((video, i) => (
          <li key={`${video}-${i}`} className="margin-top">
            {video.text && <Text text={video.text} />}
            <p>
              <Link className="link--dark" href={video.url} text={video.name} />
            </p>
          </li>
        ))}
    </ul>
  );
}

Caption.defaultProps = {
  showCourtesy: false,
  onClick: null,
  title: null,
  text: null,
  copy: null,
  videos: null
};

Caption.propTypes = {
  showCourtesy: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  copy: PropTypes.string,
  path: PropTypes.string,
  videos: PropTypes.array
};

export default Caption;



// WEBPACK FOOTER //
// ./src/components/Caption.jsx